/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76106Req {
  
  /**  */
  bizNo: string;
  /** String */
  userIdList: string[];
};



export type API76106Res = {};


// 接口函数 76106 加入聊天室（拉人加入原有聊天室）

export interface IUsePostAPI76106Return {
  /** 加入聊天室（拉人加入原有聊天室）: 接口请求状态 */
  isAPI76106Loading: boolean;
  /** 加入聊天室（拉人加入原有聊天室）: 接口请求返回数据 */
  dataAPI76106: API76106Res;
  /**  加入聊天室（拉人加入原有聊天室）: 接口数据请求方法 */
  fetchAPI76106Data: (inputs: API76106Req, config?: YWRequestConfig) => Promise<API76106Res>;
  /** 加入聊天室（拉人加入原有聊天室）: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76106 = ():IUsePostAPI76106Return => {
  let isMount = true;
  const [isAPI76106Loading, setIsAPI76106Loading] = useState(false);
  const [dataAPI76106, setDataAPI76106] = useState<API76106Res>({} as API76106Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/room/join/room`;

  const fetchAPI76106Data = async (inputs: API76106Req, config?: YWRequestConfig): Promise<API76106Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76106Req>) || {}) as API76106Req;
    
  
    if ( isMount ) {
      setIsAPI76106Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76106Res>(`${basePath}/yoaichat-web/chat/room/join/room`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76106(res || {} as API76106Res);
        setIsAPI76106Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76106Loading(false);
      }
      return false as unknown as API76106Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76106Loading,
    dataAPI76106,
    fetchAPI76106Data,
    requestUrl,
  }
}

